const initialState = {
    successMessage: { text: '', timestamp: 0 },
    errorMessage: { text: '', timestamp: 0 },
};

export default function snackbar(state = initialState, action) {
    switch (action.type) {
        case 'SHOW_SUCCESS_SNACKBAR':
            return { 
                ...state, 
                successMessage: { text: action.message, timestamp: Date.now() } 
            };
        case 'SHOW_ERROR_SNACKBAR':
            return { 
                ...state, 
                errorMessage: { text: action.message, timestamp: Date.now() } 
            };
        default:
            return state;
    }
}
